import { useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';

function useSSRMediaQuery(query: string) {
  const hasMatchedMediaQuery = useMediaQuery(query);
  const [matched, setMatched] = useState(false);

  useEffect(() => {
    setMatched(hasMatchedMediaQuery);
  }, [hasMatchedMediaQuery]);

  return matched;
}

export default useSSRMediaQuery;
